import React from "react";
import { useSelfEvaluationInfoContext } from "../Form/SelfEvaluationInfoContext";

const SectionBRatingBox = ({ requirements }) => {
    const { state } = useSelfEvaluationInfoContext();

    if (!requirements?.length) return null;

    return (
        <div className="sectionC-info">
            <div className="rating-box">
                <div className="sectionC-header">
                    <h3 className="sectionC-title">
                        Section 2 Minimum Criteria:{" "}
                        <input
                            type="text"
                            className="rating-input"
                            value={state.sectionBMinCriteria ?? ""}
                            disabled
                            readOnly
                        />
                        <span className="rating-total">/{requirements?.length ?? "N/A"}</span>
                    </h3>
                </div>
            </div>
        </div>
    );
};

export default SectionBRatingBox;